"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spacingToPixel = void 0;
exports.spacingToPixel = (size, theme) => {
    return `${theme.spacing(size)}px`;
};
